export { default as GoogleTagManagerProvider } from './googleTagManager';
export { default as JobsDetailPage } from './jobsDetailPage';
export { default as JobsPage } from './jobsPage';
export { default as NewsDetailPage } from './newsDetailPage';
export { default as NewsPage } from './newsPage';
export { default as notFoundPage } from './notFoundPage';
